import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { Classes, Dialog, FormGroup, Button, Intent } from '@blueprintjs/core'

import { SaveAsTemplateDialogModel, saveAsTemplateDialogModel } from './model'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import AppModel, { NULL as AppModelNULL } from '@client/components/App/model'
import { APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN } from '@config/app.config'

import './styles.scss'

@inject('app', 'editor')
@observer
class SaveAsTemplateDialog extends Component {
  static propTypes = {
    app: PropTypes.instanceOf(AppModel),
    editor: PropTypes.instanceOf(EditorModel),
    model: PropTypes.instanceOf(SaveAsTemplateDialogModel),
    usePortal: PropTypes.bool,
  }

  static defaultProps = {
    app: AppModelNULL,
    editor: EditorModelNULL,
    model: saveAsTemplateDialogModel,
    usePortal: true,
  }

  handleClose = () => {
    const { model } = this.props
    model.hideDialog()
  }

  handeSave = async () => {
    const { editor, model } = this.props
    await model.save(editor)
  }

  handeExit = async () => {
    window.location = `${APP_CONFIG_GET_A_NEWS_LETTER_ORIGIN}/mails/`
  }

  handleChange = (event) => {
    const { model } = this.props
    model.setName(event.target.value)
  }

  render() {
    const { model, app, usePortal } = this.props
    const { formatMessage } = app
    return (
      <If condition={model.show}>
        <Dialog
          className="save-as-template-dialog"
          icon="add"
          isOpen={model.show}
          onClose={this.handleClose}
          title={formatMessage('modal.saveAsTemplate.headerTitle')}
          usePortal={usePortal}
        >
          {!model.saved && !model.error && (
            <div className={Classes.DIALOG_BODY}>
              <p>{formatMessage('modal.saveAsTemplate.formDescription')}</p>
              <FormGroup
                label={formatMessage('modal.saveAsTemplate.templateNameLabel')}
                helperText={formatMessage(
                  'modal.saveAsTemplate.templateNameHelperText'
                )}
                labelFor="template-name"
                required={true}
              >
                <input
                  id="template-name"
                  className="bp6-input bp6-fill"
                  placeholder={formatMessage(
                    'modal.saveAsTemplate.templateNamePlaceholder'
                  )}
                  value={model.name}
                  onChange={this.handleChange}
                />
              </FormGroup>
            </div>
          )}
          {model.saved && (
            <div className={Classes.DIALOG_BODY}>
              <p className="template-saved-success bp6-ui-text bp6-ui-text-large">
                {formatMessage('modal.saveAsTemplate.savedMsg')}
              </p>
              <p className="bp6-ui-text bp6-text-muted">
                {formatMessage('modal.saveAsTemplate.templateNameHelperText')}
              </p>
            </div>
          )}
          {model.error && (
            <div className={Classes.DIALOG_BODY}>
              <p className="template-saved-error bp6-ui-text bp6-ui-text-large">
                {formatMessage('modal.saveAsTemplate.errorMsg')}
              </p>
              <p className="bp6-ui-text bp6-text-muted">
                {formatMessage('modal.saveAsTemplate.templateNameHelperText')}
              </p>
            </div>
          )}
          <div className="bp6-dialog-footer">
            <div className="bp6-dialog-footer-actions">
              {!model.saved && !model.error && (
                <Button
                  text={formatMessage('modal.common.cancelBtn')}
                  onClick={this.handleClose}
                  disabled={model.saving}
                />
              )}
              {!model.saved && !model.error && (
                <Button
                  intent={Intent.SUCCESS}
                  onClick={this.handeSave}
                  text={formatMessage('modal.saveAsTemplate.saveTemplateBtn')}
                  loading={model.saving}
                  disabled={!model.canBeSaved}
                />
              )}
              {(model.saved || model.error) && (
                <Button
                  onClick={this.handeExit}
                  text={formatMessage('modal.saveAsTemplate.exitEditorBtn')}
                />
              )}
              {(model.saved || model.error) && (
                <Button
                  intent={Intent.SUCCESS}
                  onClick={this.handleClose}
                  text={formatMessage(
                    'modal.common.continurEditingBtn'
                  )}
                />
              )}
            </div>
          </div>
        </Dialog>
      </If>
    )
  }
}

export default SaveAsTemplateDialog
